import React from 'react';

import { MenuObjectPage } from 'features/menu/pages/menu-object-page';
import { MenuProductPage } from 'features/menu/pages/menu-product-page/menu-product-page';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { CardModal } from 'components/card-modal';
import { LocationEmptyState } from 'components/location-empty-state';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { t } from 'state/intl/translations';

export default function MenuObjectRoute() {
  const { noStoreSelected } = useStoreRequired();

  if (noStoreSelected) {
    return (
      <CardModal alwaysShowHeader>
        <LocationEmptyState title={t('emptyMenuHeading')} message={t('emptyMenuMessage')} />
      </CardModal>
    );
  }
  return <MenuObjectInner />;
}

const MenuObjectInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();

  return enableUnifiedMenu ? <MenuProductPage /> : <MenuObjectPage />;
});
